import { render, staticRenderFns } from "./userStatistics.vue?vue&type=template&id=6310fb08&scoped=true"
import script from "./userStatistics.vue?vue&type=script&lang=js"
export * from "./userStatistics.vue?vue&type=script&lang=js"
import style0 from "./userStatistics.vue?vue&type=style&index=0&id=6310fb08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310fb08",
  null
  
)

export default component.exports